var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marker",class:{ cluster: _vm.isCluster }},[(_vm.isCluster)?_c('span',{staticClass:"pointCount"},[_vm._v(_vm._s(_vm.point_count))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }